import React from 'react';
import { Paper, Stack, Button, TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

/**
 * Filter bar for Movement Analysis. `sort_by` only applies to the product list.
 * Warehouse scoping comes from the sidebar warehouse selector.
 */
const MovementFilter = ({
    fromDate,
    toDate,
    onFromDateChange,
    onToDateChange,
    sortBy,
    onSortByChange,
    showSortBy = false,
    onSubmit,
    loading,
}) => {
    const { t } = useTranslation();
    return (
        <Paper
            elevation={0}
            sx={{
                p: 3, mb: 3, borderRadius: 4,
                boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                border: '1px solid rgba(0,0,0,0.08)',
                bgcolor: '#FFFFFF',
            }}
        >
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ xs: 'stretch', sm: 'center' }} flexWrap="wrap" useFlexGap>
                <TextField
                    label={t('movementAnalytics.filters.from')}
                    type="date"
                    size="small"
                    value={fromDate}
                    onChange={(e) => onFromDateChange(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    sx={{ minWidth: 160 }}
                />
                <TextField
                    label={t('movementAnalytics.filters.to')}
                    type="date"
                    size="small"
                    value={toDate}
                    onChange={(e) => onToDateChange(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    sx={{ minWidth: 160 }}
                />

                {showSortBy && (
                    <FormControl size="small" sx={{ minWidth: 180 }}>
                        <InputLabel>{t('movementAnalytics.filters.sortBy')}</InputLabel>
                        <Select label={t('movementAnalytics.filters.sortBy')} value={sortBy} onChange={(e) => onSortByChange(e.target.value)}>
                            <MenuItem value="total_movement">{t('movementAnalytics.sortOptions.totalMovement')}</MenuItem>
                            <MenuItem value="purchase">{t('movementAnalytics.sortOptions.purchase')}</MenuItem>
                            <MenuItem value="sales">{t('movementAnalytics.sortOptions.sales')}</MenuItem>
                            <MenuItem value="net_gap">{t('movementAnalytics.sortOptions.biggestGap')}</MenuItem>
                        </Select>
                    </FormControl>
                )}

                <Button
                    variant="contained"
                    onClick={onSubmit}
                    disabled={loading}
                    startIcon={<FontAwesomeIcon icon={faSearch} />}
                    sx={{ bgcolor: '#189AB4', '&:hover': { bgcolor: '#147a8f' }, textTransform: 'none', fontWeight: 700, px: 3 }}
                >
                    {t('movementAnalytics.filters.apply')}
                </Button>
            </Stack>
        </Paper>
    );
};

export default MovementFilter;
